<!-- Modal Backdrop -->
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50" (click)="close()">
  <!-- Modal Box -->
  <div
    class="bg-base-100 rounded-lg shadow-xl w-full max-w-2xl m-4"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between p-4 border-b border-base-300">
      <h3 class="text-lg font-bold">
        @if (mode === 'create') {
          Neue Position hinzufügen
        } @else {
          Position bearbeiten
        }
      </h3>
      <button class="bm-btn bm-btn-sm bm-btn-ghost bm-btn-square" (click)="close()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Content -->
    <div class="p-4 space-y-4">
      <!-- Artikelvorlage -->
      <div class="w-full">
        <label class="bm-fieldset-label">
          Artikelvorlage
          @if (mode === 'create') {
            <span class="text-error">*</span>
          }
        </label>
        @if (mode === 'create') {
          <!-- Auswählbar bei Create -->
          <button
            type="button"
            class="bm-btn w-full justify-start text-left"
            [class.bm-btn-error]="!selectedTemplate()"
            [class.border-base-300]="selectedTemplate()"
            (click)="openTemplatePicker()"
          >
            @if (selectedTemplate(); as template) {
              <div class="flex-1 min-w-0 flex items-center gap-2">
                <span class="font-medium truncate">{{ template.description }}</span>
                @if (template.part_nr) {
                  <span class="text-xs text-base-content/60">({{ template.part_nr }})</span>
                }
                @if (template.sn) {
                  <span class="badge badge-info badge-xs">SN</span>
                }
              </div>
              <i class="fa fa-pencil text-base-content/40"></i>
            } @else {
              <i class="fa fa-search mr-2"></i>
              Artikelvorlage auswählen...
            }
          </button>
        } @else {
          <!-- Nur Anzeige bei Edit -->
          <div class="p-3 bg-base-200 rounded-lg">
            @if (selectedTemplate(); as template) {
              <p class="font-medium">{{ template.description }}</p>
              <p class="text-xs text-base-content/60">
                @if (template.part_nr) {
                  Art.-Nr.: {{ template.part_nr }}
                }
                @if (template.vendor) {
                  <span class="ml-2">Hersteller: {{ template.vendor }}</span>
                }
                @if (template.sn) {
                  <span class="text-info ml-2">SN-Pflicht</span>
                }
              </p>
            }
          </div>
          <p class="text-xs text-base-content/50 mt-1">
            <i class="fa fa-lock mr-1"></i>
            Artikelvorlage kann nicht geändert werden
          </p>
        }
      </div>

      <!-- Anzahl (Soll) + Eigentümer in einer Zeile -->
      <div class="grid grid-cols-2 gap-4">
        <!-- Anzahl (Soll) -->
        <div>
          <label class="bm-fieldset-label">Anzahl (Soll) <span class="text-error">*</span></label>
          <div class="flex items-center gap-2">
            <button
              type="button"
              class="bm-btn bm-btn-square"
              [disabled]="quantityOrdered() <= minQuantity()"
              (click)="decrementQuantity()"
            >
              <i class="fa fa-minus"></i>
            </button>
            <input
              type="number"
              class="bm-input w-20 text-center"
              [ngModel]="quantityOrdered()"
              (ngModelChange)="setQuantity($event)"
              [min]="minQuantity()"
            />
            <button
              type="button"
              class="bm-btn bm-btn-square"
              (click)="incrementQuantity()"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <!-- Eigentümer -->
        <div>
          <label class="bm-fieldset-label">Eigentümer <span class="text-error">*</span></label>
          @if (canEditOwner()) {
            <!-- Auswählbar bei Create oder Edit ohne erhaltene Artikel -->
            <select
              class="bm-select w-full"
              [ngModel]="owner()"
              (ngModelChange)="owner.set($event)"
            >
              <option value="BENTOMAX">Bentomax</option>
              <option value="CUSTOMER">Kunde</option>
            </select>
          } @else {
            <!-- Nur Anzeige wenn bereits Artikel erhalten -->
            <div class="p-3 bg-base-200 rounded-lg">
              <span class="badge" [class.badge-primary]="owner() === 'BENTOMAX'" [class.badge-secondary]="owner() === 'CUSTOMER'">
                {{ getOwnerLabel(owner()) }}
              </span>
            </div>
          }
        </div>
      </div>

      <!-- Info bei Edit -->
      @if (mode === 'edit') {
        <div class="text-sm text-base-content/60 space-y-1">
          <div class="flex justify-between">
            <span>{{ quantityReceived }} bereits erhalten</span>
          </div>
          <div class="flex justify-between">
            <span>{{ quantityOpen }} noch offen</span>
          </div>
          @if (quantityReceived > 0) {
            <p class="text-xs text-warning mt-2">
              <i class="fa fa-info-circle mr-1"></i>
              Minimum ist {{ minQuantity() }}, da bereits Artikel eingegangen sind.
            </p>
            <p class="text-xs text-base-content/50">
              <i class="fa fa-lock mr-1"></i>
              Eigentümer kann nicht geändert werden
            </p>
          }
        </div>
      }
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-between p-4 border-t border-base-300 bg-base-200/50">
      <div>
        @if (mode === 'edit' && canDelete()) {
          <button
            type="button"
            class="bm-btn bm-btn-error bm-btn-sm"
            (click)="delete()"
          >
            <i class="fa fa-trash mr-1"></i>
            Löschen
          </button>
        }
        @if (mode === 'edit' && !canDelete()) {
          <span class="text-xs text-base-content/50">
            <i class="fa fa-info-circle mr-1"></i>
            Löschen nicht möglich (Artikel bereits eingegangen)
          </span>
        }
      </div>
      <div class="flex items-center gap-2">
        <button type="button" class="bm-btn bm-btn-ghost" (click)="close()">
          Abbrechen
        </button>
        <button
          type="button"
          class="bm-btn bm-btn-primary"
          [disabled]="!isValid()"
          (click)="save()"
        >
          @if (mode === 'create') {
            <i class="fa fa-plus mr-1"></i>
            Hinzufügen
          } @else {
            <i class="fa fa-check mr-1"></i>
            Speichern
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Artikelvorlagen-Picker Modal -->
@if (showTemplatePicker()) {
  <app-article-template-picker
    [project]="project"
    [customer]="customer"
    [sourceWarehouse]="sourceWarehouse"
    [warehouseArticleTemplateIds]="warehouseArticleTemplateIds"
    [initialSearchQuery]="''"
    [externalTemplates]="articleTemplates"
    (templateSelected)="onTemplateSelected($event)"
    (templatesReloaded)="onPickerTemplatesReloaded($event)"
    (closed)="closeTemplatePicker()"
  />
}
